// Global Components
import * as React from 'react';

// Components
import Section from '../../../layout/Section';

// Types
type $Props = {
  data: string;
  id: string;
};

const DescriptionSectionView = function ({
  data,
  id,
}: $Props) {
  return (
    <Section id={id}>
      <div
        dangerouslySetInnerHTML={{
          __html: data,
        }}
      />
    </Section>
  );
};

export default DescriptionSectionView;
